var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _rect6, _rect7, _path5, _path6, _path7, _polygon, _polygon2, _polygon3, _polygon4, _rect8, _rect9, _rect10, _circle, _polygon5, _polygon6, _polygon7, _path8, _path9, _path10, _path11, _ellipse, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectsIl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 393.69426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebebeb;}.cls-2{fill:#f0f0f0;}.cls-16,.cls-3{fill:#fafafa;}.cls-4{fill:#e0e0e0;}.cls-5{fill:#e6e6e6;}.cls-11,.cls-6{fill:#fff;}.cls-7{fill:#f5f5f5;}.cls-10,.cls-13,.cls-8{fill:#263238;}.cls-9{fill:#407bff;}.cls-10{opacity:0.4;}.cls-10,.cls-11,.cls-13,.cls-16,.cls-17,.cls-18{isolation:isolate;}.cls-11{opacity:0.1;}.cls-12,.cls-18{opacity:0.3;}.cls-13{opacity:0.8;}.cls-14{fill:#ffc3bd;}.cls-15{fill:#ed847e;}.cls-16,.cls-17{opacity:0.2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "project_i") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.29055,
    y: 351.16112,
    width: 92.97862,
    height: 0.29835
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.46258,
    y: 362.24788,
    width: 22.90155,
    height: 0.29835
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 181.95606,
    y: 347.92695,
    width: 51.54341,
    height: 0.29835
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 244.12082,
    y: 347.92695,
    width: 7.55429,
    height: 0.29835
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 331.72913,
    y: 355.20676,
    width: 51.57921,
    height: 0.29835
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.2527,378.28634H40.6085a5.263,5.263,0,0,1-5.20327-4.51109l-14.679-100.33a5.263,5.263,0,0,1,5.21521-6.02671H84.57376a5.251,5.251,0,0,1,5.20327,4.49914l14.679,100.342a5.263,5.263,0,0,1-5.20329,6.02674Z",
    transform: "translate(0 -65.76787)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.59,378.28634H19.93863a5.251,5.251,0,0,1-5.20327-4.51109L.05641,273.44521a5.263,5.263,0,0,1,5.20327-6.02671H32.911a5.27484,5.27484,0,0,1,5.21521,4.49914l14.667,100.342A5.263,5.263,0,0,1,47.59,378.28634Z",
    transform: "translate(0 -65.76787)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M397.54572,241.9869H112.53536c-7.244,0-13.60487,5.43-14.22545,12.12506l-7.16046,77.46431c-.62057,6.695,4.77364,12.125,11.9341,12.125H388.07c7.244,0,13.60487-5.43,14.22547-12.125L409.456,254.112C410.14813,247.41692,404.78973,241.9869,397.54572,241.9869Z",
    transform: "translate(0 -65.76787)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M378.20051,241.9869H93.214c-7.244,0-13.60488,5.43-14.22545,12.12506l-7.16047,77.46431c-.62057,6.695,4.77365,12.125,11.93411,12.125H368.74871c7.244,0,13.61682-5.43,14.22547-12.125l7.16047-77.4643C390.803,247.41692,385.44452,241.9869,378.20051,241.9869Z",
    transform: "translate(0 -65.76787)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.24463,
    y: 267.76557,
    width: 124.50856,
    height: 44.7529,
    rx: 8.58063
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.44775,
    y: 267.76557,
    width: 140.98952,
    height: 44.7529,
    rx: 7.85263
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.59387,267.75363H314.87814a7.85263,7.85263,0,0,1,7.85263,7.85263V304.6539a7.85263,7.85263,0,0,1-7.85263,7.85263H189.59388a7.85264,7.85264,0,0,1-7.85264-7.85264V275.60625A7.85263,7.85263,0,0,1,189.59387,267.75363Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.77,378.28634H353.15083a4.58268,4.58268,0,0,1-4.45144-6.02671l27.44845-100.34195a6.19378,6.19378,0,0,1,5.788-4.49915H425.555a4.58266,4.58266,0,0,1,4.43949,6.02671l-27.44844,100.33A6.16993,6.16993,0,0,1,396.77,378.28634Z",
    transform: "translate(0 -65.76787)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M360.12034,378.28634H332.469a4.58266,4.58266,0,0,1-4.43948-6.02671L355.478,271.91768a6.18189,6.18189,0,0,1,5.788-4.49915h27.66325a4.58268,4.58268,0,0,1,4.45144,6.02671l-27.44845,100.33A6.19376,6.19376,0,0,1,360.12034,378.28634Z",
    transform: "translate(0 -65.76787)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "336.992 339.8 332.791 339.8 322.731 312.518 333.137 312.518 336.992 339.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "390.242 339.8 386.041 339.8 375.981 312.518 386.375 312.518 390.242 339.8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "87.557 339.8 91.758 339.8 101.807 312.518 91.412 312.518 87.557 339.8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "34.307 339.8 38.508 339.8 48.557 312.518 38.174 312.518 34.307 339.8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 79.91945,
    width: 318.23492,
    height: 113.50529
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.99559,
    width: 318.2349,
    height: 113.50529
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 86.55483,
    y: 9.54729,
    width: 299.14032,
    height: 94.4107
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 236.12497,
    cy: 56.74668,
    r: 28.3077
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "135.103 103.958 154.937 9.547 198.688 9.547 178.865 103.958 135.103 103.958"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "197.327 103.958 217.162 9.547 239.037 9.547 219.214 103.958 197.327 103.958"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "330.918 103.958 350.752 9.547 372.627 9.547 352.805 103.958 330.918 103.958"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M468.50591,249.66052c-7.423,32.22211,10.7407,65.42277,3.30573,97.59711l-7.35141-.3103-7.35141-.29835C469.43677,314.66562,456.23765,281.632,468.50591,249.66052Z",
    transform: "translate(0 -65.76787)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M449.471,263.61151c6.08641,30.76613-13.43781,61.53226-7.35141,92.29838h14.71477C445.84305,325.13182,460.46233,294.37764,449.471,263.61151Z",
    transform: "translate(0 -65.76787)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M463.064,238.01284c-9.73824,32.80685,8.35388,68.21536-1.38436,101.02221l-7.99587-.75186-7.99586-.73991C460.76069,305.24959,447.99118,270.34233,463.064,238.01284Z",
    transform: "translate(0 -65.76787)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M477.39683,285.28382c3.13868,17.73407-14.32092,31.685-11.23,49.43105l5.96705,1.086,5.967,1.086C470.94048,318.42486,484.4857,303.74588,477.39683,285.28382Z",
    transform: "translate(0 -65.76787)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 459.84174,
    cy: 303.7827,
    rx: 40.15826,
    ry: 44.96771
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-113"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-113",
    className: "cls-7",
    cx: 239.0369,
    cy: 380.18484,
    rx: 231.39042,
    ry: 13.50942
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-113"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M398.71524,276.90609h-257.896a4.77362,4.77362,0,0,1-4.78152-4.76574q-.00025-.14127.00788-.2824l8.7119-158.115a5.41809,5.41809,0,0,1,5.33455-5.04813H407.98806a4.77366,4.77366,0,0,1,4.78155,4.76574q.00021.14127-.0079.28239l-8.688,158.115A5.39422,5.39422,0,0,1,398.71524,276.90609Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M290.2223,135.58239H265.29194a14.17766,14.17766,0,0,1-14.34974-14.00358q-.00672-.54687.02881-1.09305l.2506-4.60657a15.68142,15.68142,0,0,1,15.44274-14.61928h24.91842a14.18961,14.18961,0,0,1,14.34908,14.0284q.00608.53445-.02815,1.06824l-.25061,4.60656A15.70528,15.70528,0,0,1,290.2223,135.58239Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "312.921 375.196 304.937 375.196 282.942 39.013 290.938 39.013 312.921 375.196"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "252.964 375.196 260.96 375.196 282.942 39.013 274.959 39.013 252.964 375.196"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M397.34282,276.90609h-257.896a4.77362,4.77362,0,0,1-4.78153-4.76574q-.00024-.14127.00789-.2824l8.6761-158.115a5.41808,5.41808,0,0,1,5.33455-5.04813H406.57985a4.77365,4.77365,0,0,1,4.78154,4.76574q.00023.14128-.0079.28239l-8.688,158.115A5.39423,5.39423,0,0,1,397.34282,276.90609Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M143.564,272.06084a3.78308,3.78308,0,0,1-3.827-3.73873q-.00172-.1476.00806-.295l8.27033-150.4533a4.30821,4.30821,0,0,1,4.24854-4.03373H402.53417a3.78315,3.78315,0,0,1,3.827,3.73871q.00169.14762-.00808.295l-8.27033,150.4533a4.3082,4.3082,0,0,1-4.26049,4.03373Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M395.3737,192.31715H320.00982a3.21026,3.21026,0,0,1-3.253-3.167q-.00176-.12915.00692-.25811l3.75923-68.48984a.46545.46545,0,0,0-.44079-.48883l-.01271-.00048a.52511.52511,0,0,0-.51316.48931l-3.75923,68.48984a3.6757,3.6757,0,0,1-3.58024,3.42508H233.90523a3.21026,3.21026,0,0,1-3.253-3.167q-.00174-.12915.00692-.25811l3.75924-68.48984a.46544.46544,0,0,0-.44081-.48883l-.01269-.00048a.52511.52511,0,0,0-.51316.48931l-3.75924,68.48984a3.6757,3.6757,0,0,1-3.58023,3.42508H150.72451a.51317.51317,0,0,0-.51316.4893.4535.4535,0,0,0,.429.47674q.01224.00063.02449.00062h75.32808a3.22221,3.22221,0,0,1,3.25311,3.191q.00117.12311-.007.246l-3.75924,68.47789a.44153.44153,0,0,0,.4535.48931.52511.52511,0,0,0,.51316-.48931l3.75924-68.47791a3.66379,3.66379,0,0,1,3.58023-3.437h78.2758a3.22235,3.22235,0,0,1,3.35349,3.437L311.656,265.19873a.44153.44153,0,0,0,.4535.48931.52511.52511,0,0,0,.51316-.48931l3.75924-68.47791a3.66379,3.66379,0,0,1,3.58023-3.437h75.32808a.52509.52509,0,0,0,.51315-.47736.45349.45349,0,0,0-.41569-.48837Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "272.512 66.557 242.259 66.557 240.564 97.335 270.782 98.146 272.512 66.557"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.24212,162.58929l-30.3723-1.47984a266.73872,266.73872,0,0,0,3.16253-31.39863l30.5394,1.47983A266.91191,266.91191,0,0,1,269.24212,162.58929Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "308.995 87.119 278.694 89.434 279.362 120.105 309.675 118.601 308.995 87.119"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M308.028,183.17562l-30.52743.84733a263.46469,263.46469,0,0,0,.7638-31.41058l30.69453-.87118A263.94866,263.94866,0,0,1,308.028,183.17562Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "220.515 143.078 164.664 140.954 159.639 190.635 215.372 194.072 220.515 143.078"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.59091,257.59671l-55.89935-4.54689a381.68648,381.68648,0,0,0,7.75717-50.60061l56.23351,4.535A378.84727,378.84727,0,0,1,212.59091,257.59671Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M163.02857,139.282h0a2.9716,2.9716,0,0,1-2.98888-2.95421q-.00057-.09825.00535-.1964h0a3.38928,3.38928,0,0,1,3.32963-3.13867h0a2.95967,2.95967,0,0,1,2.97772,2.94149q.00061.10462-.00612.20911h0A3.37738,3.37738,0,0,1,163.02857,139.282Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M212.37611,139.282H173.62606a2.95968,2.95968,0,0,1-2.97772-2.9415q-.00061-.10463.00612-.20911h0a3.36542,3.36542,0,0,1,3.31768-3.1506h38.80972a2.97159,2.97159,0,0,1,2.98888,2.95421q.00059.09825-.00535.19639h0A3.38929,3.38929,0,0,1,212.37611,139.282Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M162.27671,153.01813h0a2.95966,2.95966,0,0,1-2.98955-2.92947q-.00113-.11064.006-.22114h0a3.37734,3.37734,0,0,1,3.36542-3.1506h0a2.95967,2.95967,0,0,1,2.97772,2.9415q.00063.10461-.00612.2091h0A3.37736,3.37736,0,0,1,162.27671,153.01813Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M218.48637,153.01813H172.87421a2.9716,2.9716,0,0,1-2.98888-2.95421q-.00059-.09825.00535-.1964h0a3.38929,3.38929,0,0,1,3.32961-3.1506h45.61216a2.97159,2.97159,0,0,1,2.98888,2.95421q.00057.09825-.00536.19639h0A3.38929,3.38929,0,0,1,218.48637,153.01813Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M161.4652,166.74235h0a2.94772,2.94772,0,0,1-2.97764-2.9175q-.00113-.11065.006-.22118h0a3.36543,3.36543,0,0,1,3.31768-3.1506h0a2.95966,2.95966,0,0,1,2.98956,2.92946q.00113.11065-.006.22114h0A3.37735,3.37735,0,0,1,161.4652,166.74235Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M194.3198,166.74235H172.11043a2.94772,2.94772,0,0,1-2.97765-2.9175q-.00113-.11065.00605-.22118h0a3.36541,3.36541,0,0,1,3.31768-3.1506h22.20937a2.94775,2.94775,0,0,1,2.97845,2.9167q.0012.117-.00685.2339h0A3.36543,3.36543,0,0,1,194.3198,166.74235Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M214.88226,180.4785H192.67289a2.95967,2.95967,0,0,1-2.97772-2.9415q-.00063-.10461.00612-.2091h0a3.37735,3.37735,0,0,1,3.31768-3.15061h22.20937a2.95968,2.95968,0,0,1,2.97772,2.9415q.00063.10462-.00612.20911h0A3.37735,3.37735,0,0,1,214.88226,180.4785Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M160.7611,180.4785h0a2.95967,2.95967,0,0,1-2.97772-2.9415q-.00063-.10461.00612-.2091h0a3.37735,3.37735,0,0,1,3.31768-3.15061h0a2.95967,2.95967,0,0,1,2.97771,2.9415q.00063.10462-.00611.20911h0A3.37736,3.37736,0,0,1,160.7611,180.4785Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M181.61,180.4785H171.35859a2.95967,2.95967,0,0,1-2.97772-2.9415q-.00063-.10461.00612-.2091h0a3.37735,3.37735,0,0,1,3.31768-3.15061h10.25139a2.95966,2.95966,0,0,1,2.98956,2.92946q.00111.11065-.006.22115h0A3.37735,3.37735,0,0,1,181.61,180.4785Z",
    transform: "translate(0 -65.76787)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "257.105 155.573 242.08 155.573 240.016 193.177 255.041 193.177 257.105 155.573"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "279.911 163.33 264.874 163.33 263.239 193.177 278.264 193.177 279.911 163.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "304.221 143.305 289.196 143.305 286.463 193.177 301.488 193.177 304.221 143.305"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.43358,242.55973c-1.49176,0-2.99545,0-4.51109-.11935a25.551,25.551,0,0,1-9.09378-1.83784.9786.9786,0,0,1-.48931-1.28889.96668.96668,0,0,1,1.27938-.48173l.00951.00437a23.86831,23.86831,0,0,0,8.35388,1.67077c18.03241.93086,33.82125-3.77118,49.71749-14.77443a55.637,55.637,0,0,0,12.92462-12.53081.96666.96666,0,1,1,1.58722,1.09794,56.09043,56.09043,0,0,1-13.37812,12.97238C276.91574,237.66676,262.0578,242.55973,245.43358,242.55973Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.49092,220.62484a.96665.96665,0,0,1-.89506-1.33662,17.07758,17.07758,0,0,0,.8354-10.44234,65.0526,65.0526,0,0,1-12.0057,6.37281.96666.96666,0,1,1-.78118-1.76847q.02628-.01164.05321-.02165a63.35835,63.35835,0,0,0,12.73371-6.93371.97865.97865,0,0,1,1.46791.4893,18.84387,18.84387,0,0,1-.51316,13.044A.96665.96665,0,0,1,307.49092,220.62484Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M386.626,183.5575H330.72663a3.35349,3.35349,0,0,1-3.38488-3.32179q-.0012-.12932.00754-.25844l2.60163-47.25907a3.75922,3.75922,0,0,1,3.69958-3.50863h55.9113a3.35347,3.35347,0,0,1,3.373,3.33379q.00071.12333-.00761.24644l-2.60163,47.25907A3.75923,3.75923,0,0,1,386.626,183.5575Zm-52.97548-53.36933a2.7687,2.7687,0,0,0-2.73292,2.60163L328.316,180.04887a2.38681,2.38681,0,0,0,2.22661,2.53693q.08.00522.16021.005h55.89935a2.76869,2.76869,0,0,0,2.73292-2.60162l2.60163-47.25908a2.372,2.372,0,0,0-2.39877-2.542Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M391.91282,142.77866H329.85546a.4893.4893,0,0,1,0-.96666h62.05736a.4893.4893,0,1,1,0,.96666Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M342.31467,183.5575h0a.48933.48933,0,0,1-.4535-.51316L344.057,142.2655a.47738.47738,0,0,1,.49932-.45436l.01384.00086a.48933.48933,0,0,1,.4535.51316L342.792,183.116A.48929.48929,0,0,1,342.31467,183.5575Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M384.812,147.6239h-33.6661a.4893.4893,0,0,1,0-.96666H384.812a.4893.4893,0,1,1,0,.96666Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M379.74,153.5671H350.8237a.4893.4893,0,1,1,0-.96666H379.74a.4893.4893,0,1,1,0,.96666Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M367.31661,159.70123h-16.8271a.4893.4893,0,1,1,0-.96666h16.8271a.4893.4893,0,1,1,0,.96666Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M370.37173,171.68307H349.83315a.4893.4893,0,1,1,0-.96666h20.53858a.4893.4893,0,1,1,0,.96666Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M366.32609,177.8172h-16.839a.4893.4893,0,0,1,0-.96666h16.839a.4893.4893,0,0,1,0,.96666Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M376.17173,177.8172h-5.38229a.4893.4893,0,1,1,0-.96666h5.38229a.4893.4893,0,1,1,0,.96666Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M381.68528,165.65634H350.15535a.4893.4893,0,0,1,0-.9786h31.52993a.4893.4893,0,0,1,0,.9786Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M352.29157,252.33377c-7.30367,0-13.28267-2.16007-16.99416-6.16993-3.974-4.28434-5.62095-11.02713-4.523-18.49787a22.3287,22.3287,0,0,1,14.26127-18.76042,34.15542,34.15542,0,0,1,28.91635.3819c3.92633,1.96912,6.38476,4.46336,7.31562,7.41109a.97.97,0,0,1-1.84978.58478c-.7638-2.38682-2.9-4.535-6.337-6.26541a32.22206,32.22206,0,0,0-27.2575-.34608,20.43117,20.43117,0,0,0-13.12752,17.28058c-1.0144,6.886.4535,13.044,4.02179,16.88676,4.95265,5.35842,13.12752,5.7403,17.61475,5.50162,8.28228-.46543,15.395-3.35348,20.04929-8.13907,5.442-5.609,6.96951-13.98677,3.58023-19.50032a6.11024,6.11024,0,0,0-4.18888-3.10288.96666.96666,0,0,1,.19095-1.92139,7.75714,7.75714,0,0,1,5.64484,3.99793c3.86664,6.25348,2.23168,15.64562-3.807,21.87522-5.00039,5.1436-12.56661,8.23453-21.33819,8.72383C353.71173,252.33377,352.99568,252.33377,352.29157,252.33377Z",
    transform: "translate(0 -65.76787)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-113"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M104.56339,151.29961l-3.449,5.96706-3.36542,6.1222c-2.21975,4.09339-4.344,8.2226-6.27735,12.36373-.96666,2.08847-1.88559,4.15307-2.721,6.22961l-.15514.3819v.08355a.95446.95446,0,0,0-.1074.16707,3.15136,3.15136,0,0,0-.16708.34608,2.49423,2.49423,0,0,0,.14321,1.33662,13.28273,13.28273,0,0,0,2.87613,4.35594,51.31734,51.31734,0,0,0,4.66623,4.41562L93.20212,199.036a29.23844,29.23844,0,0,1-3.85472-1.36049,31.74571,31.74571,0,0,1-3.58023-1.86171,20.813,20.813,0,0,1-6.73083-6.24154,13.9152,13.9152,0,0,1-2.10041-5.442,12.3162,12.3162,0,0,1,0-3.24608,9.79641,9.79641,0,0,1,.27449-1.58723l.191-.77571.14321-.47736c.77572-2.38682,1.56337-4.85719,2.49422-7.16047,1.814-4.67816,3.86665-9.21313,6.0864-13.61682,1.12181-2.19587,2.26748-4.37981,3.48475-6.528s2.38683-4.24854,3.81892-6.42056Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M92.96343,192.42455l6.26541-1.635.358,10.12011s-4.90492.728-7.90038-2.26747Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "108.12 123.315 106.7 132.206 99.587 135.142 99.229 125.022 108.12 123.315"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M134.01676,103.58706c.1432.69218.62058,1.19341,1.07406,1.086s.716-.728.57283-1.42016-.62058-1.19341-1.07406-1.086S133.92128,102.89488,134.01676,103.58706Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M134.61346,104.78047a25.31292,25.31292,0,0,0,4.51109,5.251,4.03371,4.03371,0,0,1-3.17447,1.28888Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M130.73488,100.25744a.4122.4122,0,0,1-.28552-.69306l.011-.011a4.12916,4.12916,0,0,1,3.58023-1.37242.40577.40577,0,0,1,.33636.46492l-.00221.01244a.41767.41767,0,0,1-.47735.34609h0a3.29379,3.29379,0,0,0-2.78065,1.10988A.40579.40579,0,0,1,130.73488,100.25744Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M114.31355,113.32529c1.265,6.42056,2.5181,18.17564-1.96912,22.44806,0,0,1.75432,6.50408,13.66455,6.50408,13.12752,0,6.26541-6.50408,6.26541-6.50408-7.16047-1.70657-6.96952-7.00532-5.71643-11.99379Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M109.75472,136.96676c-.95474-1.77819-2.01687-3.81891.16707-4.46337,2.38682-.7041,17.82956-2.00492,22.36453-.68025-1.39629,2.47037.95473,5.51355.95473,5.51355Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.93307,435.97581a2.84032,2.84032,0,0,0,2.18394-.11935.8473.8473,0,0,0,.20288-.96665.96672.96672,0,0,0-.537-.60866c-1.19341-.5609-3.90245.549-4.0218.59671a.191.191,0,0,0-.13128.179.21481.21481,0,0,0,.11934.191A10.94193,10.94193,0,0,0,70.93307,435.97581Zm1.42016-1.3963a1.25142,1.25142,0,0,1,.25061.0716.57281.57281,0,0,1,.31029.358c.11934.3819,0,.4893-.0716.53705-.46543.39381-2.21974,0-3.449-.46545A6.76626,6.76626,0,0,1,72.35323,434.57951Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M68.79686,435.27171h.09548c.99053-.28641,3.1148-1.79012,3.13866-2.78064a.68025.68025,0,0,0-.5251-.68025,1.12174,1.12174,0,0,0-.91892.0716c-1.19341.60865-1.9214,3.03128-1.94526,3.13868a.21483.21483,0,0,0,0,.2029Zm2.4823-3.10288h.08353c.26256.09546.26256.21481.26256.2745,0,.58476-1.42016,1.76626-2.38682,2.24362a5.09581,5.09581,0,0,1,1.59916-2.47037A.74.74,0,0,1,71.27916,432.16883Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M135.66367,437.44369c1.12181,0,2.20782-.15515,2.57777-.65637a.79959.79959,0,0,0,0-.907,1.03826,1.03826,0,0,0-.65638-.4893c-1.456-.39381-4.523,1.34856-4.65429,1.4321a.19092.19092,0,0,0-.09548.21481.20287.20287,0,0,0,.15515.16709A16.025,16.025,0,0,0,135.66367,437.44369ZM137.048,435.749a1.4559,1.4559,0,0,1,.40576,0,.60864.60864,0,0,1,.40575.2864c.1432.26255.09548.39381,0,.46545-.40575.56091-2.6255.57285-4.24854.3461a9.33243,9.33243,0,0,1,3.437-1.09792Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M133.0143,437.205h.08354c1.06214-.47735,3.15061-2.38682,2.99546-3.36542,0-.2387-.20288-.52511-.77571-.58476a1.58716,1.58716,0,0,0-1.19341.358c-1.10987.91891-1.34856,3.28188-1.36049,3.37733a.25059.25059,0,0,0,.09548.19095A.20281.20281,0,0,0,133.0143,437.205Zm2.13619-3.58023h.11935c.3819,0,.40576.179.40576.22675.09547.59671-1.32469,2.08847-2.38682,2.73292a4.77366,4.77366,0,0,1,1.19341-2.69712,1.0979,1.0979,0,0,1,.728-.23869Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "123.372 371.234 132.143 371.234 133.014 350.922 124.243 350.922 123.372 371.234"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "59.023 367.177 67.592 369.026 76.196 350.123 67.627 348.261 59.023 367.177"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M68.37917,433.93509l-9.54729-2.08847a.7638.7638,0,0,0-.84732.42961L54.643,439.53215a1.27693,1.27693,0,0,0,.91892,1.79012c3.37736.66831,5.04813.82346,9.28473,1.74237,2.60164.5609,8.48516,1.993,12.07732,2.78063s4.77365-2.68517,3.437-3.31768c-6.28927-2.87612-8.91478-5.40615-10.62135-7.76912A2.14821,2.14821,0,0,0,68.37917,433.93509Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M132.08344,435.98776h-9.54729a.75189.75189,0,0,0-.73991.5967l-1.73044,7.793a1.265,1.265,0,0,0,1.25309,1.55142c3.46088,0,8.44935-.2506,12.79336-.2506,5.072,0,9.45181.2745,15.40694.2745,3.58023,0,4.60656-3.63989,3.09093-3.974-6.85019-1.49176-12.45921-1.65885-18.37852-5.31069A4.10551,4.10551,0,0,0,132.08344,435.98776Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M96.63913,137.76634c-8.21067,1.88559-14.98924,22.86575-14.98924,22.86575l16.56455,12.56662a36.08881,36.08881,0,0,0,8.7477-16.20652C109.73084,146.00087,105.04075,135.833,96.63913,137.76634Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M96.63913,137.76634c-8.21067,1.88559-14.98924,22.86575-14.98924,22.86575l16.56455,12.56662a36.08881,36.08881,0,0,0,8.7477-16.20652C109.73084,146.00087,105.04075,135.833,96.63913,137.76634Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M103.68026,153.1852c-4.46336,4.41562-5.96705,12.45921-6.26541,19.4526l.728.56091a36.04088,36.04088,0,0,0,8.75963-16.20652c.16708-.65638.31028-1.31276.42963-1.9572Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M145.75991,138.20789s9.33248,10.53782.51316,75.78159H99.40785c-.32223-7.16047,4.20081-42.31834-2.74485-76.23509a122.755,122.755,0,0,1,15.70529-1.98106,173.36139,173.36139,0,0,1,19.92995,0A87.71679,87.71679,0,0,1,145.75991,138.20789Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M145.75991,138.20789s9.33248,10.53782.51316,75.78159H99.40785c-.32223-7.16047,4.20081-42.31834-2.74485-76.23509a122.755,122.755,0,0,1,15.70529-1.98106,173.36139,173.36139,0,0,1,19.92995,0A87.71679,87.71679,0,0,1,145.75991,138.20789Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M149.85332,158.1498l-.179-.15515-10.65717,2.55389c-.60863,7.16047,6.80244,15.82462,10.62135,19.76288A204.60869,204.60869,0,0,0,149.85332,158.1498Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "133.014 350.934 132.561 361.401 123.789 361.401 124.243 350.934 133.014 350.934"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "67.615 348.261 76.196 350.123 71.757 359.873 63.176 358.011 67.615 348.261"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M110.64977,106.80926c2.24362,8.41355,3.13868,13.4378,8.35388,16.9345,7.793,5.263,17.50733-.77571,17.81763-9.67856.27448-8.01972-3.46088-20.41926-12.48308-22.1139a11.86251,11.86251,0,0,0-13.68843,14.858Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M114.50448,120.52156c3.58024,2.04074,16.60035-4.77365,13.92711-15.15631,0,0,4.96459-5.96706,4.40368-12.55469s-5.08392-9.09379-9.89336-7.67363c-4.23661,1.19341-4.11727,3.58023-4.11727,3.58023s-20.03735,2.38682-15.753,10.51395C94.90868,108.09815,110.04114,117.96766,114.50448,120.52156Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M103.63251,99.87555s-2.38682-4.1292-5.87158-1.814C99.40785,98.08543,102.08109,98.38379,103.63251,99.87555Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M132.19084,97.19037s4.36789-9.85757-2.38682-13.032A16.851,16.851,0,0,1,132.19084,97.19037Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M124.94683,107.16729a9.79793,9.79793,0,0,0,3.58023,5.22714c2.27942,1.69464,3.986,0,3.83086-2.55389-.15515-2.32715-1.51564-5.96706-4.03374-6.695S124.29047,104.63726,124.94683,107.16729Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129.64887,213.98948s-9.953,66.98614-15.41886,92.04777C108.263,333.4857,76.17214,424.47132,76.17214,424.47132l-15.69335-3.40123S82.9149,346.95928,87.92723,308.53144C91.782,279.01838,99.384,213.94169,99.384,213.94169Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M79.93138,419.28c.07161,0-2.92385,5.68065-2.92385,5.68065L59.357,421.12982l1.47982-5.29875Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M123.35961,237.85769c-11.50448,2.25554-10.2872,45.15866-8.90285,67.22485,3.31768-15.59789,8.17487-45.61216,11.49255-66.91455A3.92634,3.92634,0,0,0,123.35961,237.85769Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146.27309,213.98948s1.19341,65.554.26255,92.28647C145.54511,334.0824,135.795,425.13966,135.795,425.13966H120.97279s-.537-89.4342-1.19341-116.73944c-.71606-29.83527-4.30822-94.41073-4.30822-94.41073Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "228.726 102.013 198.473 102.013 196.778 132.779 226.995 133.59 228.726 102.013"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M212.78186,187.57931,182.48117,183.832a261.35651,261.35651,0,0,0,5.45389-30.94513l30.4797,3.74731A261.62039,261.62039,0,0,1,212.78186,187.57931Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M138.683,419.22032c.0716,0-.83539,6.16995-.83539,6.16995H119.77938l-.48931-5.50161Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M150.08007,146.20376c1.34856,2.1004,2.88806,4.46336,4.42757,6.63536s3.12673,4.39174,4.77364,6.50409a89.07744,89.07744,0,0,0,10.45427,11.65962,36.66914,36.66914,0,0,0,2.81645,2.38683l.716.537a2.76754,2.76754,0,0,0-.4177-.14321h-.3819a3.89059,3.89059,0,0,0,1.96912-.4535,22.2685,22.2685,0,0,0,3.01933-1.56336,104.80748,104.80748,0,0,0,12.65016-9.73824l5.11972,4.12921a60.4698,60.4698,0,0,1-11.4806,13.9987,27.13853,27.13853,0,0,1-4.09339,3.01933,16.07526,16.07526,0,0,1-6.02673,2.24362,10.64531,10.64531,0,0,1-4.55884-.39383,10.34652,10.34652,0,0,1-2.32714-1.06213l-1.02634-.65638c-1.37241-.88313-2.67324-1.82592-3.90246-2.79258a86.36871,86.36871,0,0,1-12.91269-12.91271c-1.87366-2.31522-3.68763-4.6543-5.37035-7.08887s-3.2938-4.77364-4.86912-7.54236Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M132.82335,151.46669c-2.80453,11.7551,18.46206,23.27151,18.46206,23.27151l13.8197-16.18265a114.41165,114.41165,0,0,0-14.118-17.0419C141.36817,132.24084,134.99536,142.54,132.82335,151.46669Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M132.82335,151.46669c-2.80453,11.7551,18.46206,23.27151,18.46206,23.27151l13.8197-16.18265a114.41165,114.41165,0,0,0-14.118-17.0419C141.36817,132.24084,134.99536,142.54,132.82335,151.46669Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M188.6511,164.47488l3.26995-10.47815,8.58063,4.28434s-1.25309,7.63782-7.50655,8.96251Z",
    transform: "translate(0 -65.76787)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "195.358 85.329 203.091 87.465 200.502 92.513 191.909 88.229 195.358 85.329"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIl);
export default __webpack_public_path__ + "static/media/projects-il.c0d103e47e1a424a8f48815019e5f8b6.svg";
export { ForwardRef as ReactComponent };